import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Paper, Typography } from '@material-ui/core';
import ProductContainer from './ProductContainer';
import Message from '../../../common/Message';
import { useProductListStyles } from './styles';
import NoImage from '../../../../assets/noImage.png';
import { textMapper } from '../../../../helpers/FormHelper';

const ProductList = ({ ...props }) => {
  const { products, orderId, mobile, motiveId, state, issueFormName } = props;
  const classes = useProductListStyles({ mobile });
  const [value, setValue] = useState();

  const handleChange = (data) => {
    setValue(data);
  };

  return (
    <Paper className={classes.container}>
      <Typography className={classes.title}>
        Productos de tu orden de compra: <span>{orderId}</span>
      </Typography>
      <Message
        severity="info"
        message="Sólo puedes seleccionar un producto por solicitud de inconveniente"
      />
      {products.map((product, index) => (
        <Box padding="0px 17px" key={index}>
          <ProductContainer
            image={product?.image ? product.image : NoImage}
            title={product.description}
            sku={product.sku}
            purchaseDate={product.sale_date}
            commune={product.comuna}
            orderId={product.order_id}
            cud={product.cud}
            value={value}
            onChange={handleChange}
            mobile={mobile}
            product={product}
            products={products}
            redirect={textMapper.get(motiveId).redirect}
            state={state}
            issueFormName={issueFormName}
            price={product.price}
          />
          <Divider />
        </Box>
      ))}
    </Paper>
  );
};

ProductList.propTypes = {
  products: PropTypes.array,
  orderId: PropTypes.string,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  state: PropTypes.object,
  issueFormName: PropTypes.string,
};

export default ProductList;
